// JW-3113
// import Icon from "components/Elements/Icon/Icon.tsx";
// import CancelSubscriptionSideElement from "./CancelSubscriptionSideElement.js";
// import "./MyAccountSideElements.scss";
// import { useContent } from "contexts/contentContext/contentContext.js";

// const SideElementContainer = ({ setShowElement, setUserIsAutoRenew }) => {
//   const { getDirection } = useContent();
//   return (
//     <div
//       className={`my-account-side-element ${
//         getDirection() === "rtl" ? "rtl-side-element" : ""
//       }`}
//     >
//       <div className="my-account-side-element-container">
//         <div className="my-account-side-element-container-header">
//           <Icon name="x" onClick={() => setShowElement(false)} />
//         </div>
//         <div className="my-account-side-element-container-body">
//           <CancelSubscriptionSideElement
//             setShowElement={setShowElement}
//             setUserIsAutoRenew={setUserIsAutoRenew}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SideElementContainer;

import Icon from "components/Elements/Icon/Icon.tsx";
import React from "react";
import CancelSubscriptionSideElement from "./CancelSubscriptionSideElement.js";
import "./MyAccountSideElements.scss";
import { useContent } from "contexts/contentContext/contentContext.js";

const SideElementContainer = ({
  setShowElement,
  elementName,
  setUserIsAutoRenew,
}) => {
  const { getDirection } = useContent();
  const elementNamesEnums = {
    "cancel-subscription": (
      <CancelSubscriptionSideElement
        setShowElement={setShowElement}
        setUserIsAutoRenew={setUserIsAutoRenew}
      />
    ),
  };
  return (
    <div
      className={`my-account-side-element ${
        getDirection() === "rtl" ? "rtl-side-element" : ""
      }`}
    >
      <div className="my-account-side-element-container">
        <div className="my-account-side-element-container-header">
          <Icon name="x" onClick={() => setShowElement(false)} />
        </div>
        <div className="my-account-side-element-container-body">
          {elementNamesEnums[elementName]}
        </div>
      </div>
    </div>
  );
};

export default SideElementContainer;
